<h2>
  {{ 'components.gamePlayEdit.titre' | transloco }} #{{ gamePlayNumber }}
  <button mat-flat-button data-testid="backGamePlayEdit" (click)="back()">{{ 'components.gamePlayEdit.back' | transloco }}</button>
  <button class="btn-save" mat-flat-button data-testid="saveGamePlayEdit" (click)="save()">{{ 'components.gamePlayEdit.save' | transloco }}</button>

</h2>

@if (editedGamePlay && gamePlayForm) {
  <section class="edition">
    <form [formGroup]="gamePlayForm">
      <div class="row">
        <div class="col">
          <label>
            <span>{{ 'components.gamePlayEdit.odk' | transloco }}</span>
            <select formControlName="odk">
              <option value="" selected></option>
              @for (key of odkKeys; track key) {
                <option [value]="odkEnum[key]">{{key}}</option>
              }
            </select>
          </label>
          @if (gamePlayForm.controls['odk'].errors?.['required']) {
            <div class="error">
              {{ 'components.gamePlayEdit.odkEstObligatoire' | transloco }}
            </div>
          }
          <label>
            <span>{{ 'components.gamePlayEdit.down' | transloco }}</span>
            <select formControlName="down">
              <option value="" selected></option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              @if (game.getNumberOfDowns() === 4) {
                <option value="4">4</option>
              }
            </select>
          </label>
          @if (gamePlayForm.controls['down'].errors?.['required']) {
            <div class="error">
              {{ 'components.gamePlayEdit.downEstObligatoire' | transloco }}
            </div>
          }
          <label>
            <span>{{ 'components.gamePlayEdit.distance' | transloco }}</span>
            <input type="number" formControlName="distance">
          </label>
          @if (gamePlayForm.controls['distance'].errors?.['required']) {
            <div class="error">
              {{ 'components.gamePlayEdit.distanceEstObligatoire' | transloco }}
            </div>
          }
          <label>
            <span>{{ 'components.gamePlayEdit.yardLine' | transloco }}</span>
            <input type="text" formControlName="yardLine">
          </label>
          @if (gamePlayForm.controls['yardLine'].errors?.['required']) {
            <div class="error">
              {{ 'components.gamePlayEdit.yardLineEstObligatoire' | transloco }}
            </div>
          }
          <label>
            <span>{{ 'components.gamePlayEdit.hash' | transloco }}</span>
            <select formControlName="hash">
              <option value="" selected></option>
              @for (key of hashKeys; track key) {
                <option [value]="hashEnum[key]">{{key}}</option>
              }
            </select>
          </label>
          @if (gamePlayForm.controls['hash'].errors?.['required']) {
            <div class="error">
              {{ 'components.gamePlayEdit.hashEstObligatoire' | transloco }}
            </div>
          }
          <label>
            <span>{{ 'components.gamePlayEdit.qtr' | transloco }}</span>
            <select formControlName="qtr">
              <option value="" selected></option>
              @for (qtr of qtrEnum; track qtr) {
                <option [value]="qtr">{{qtr}}</option>
              }
            </select>
          </label>
          @if (gamePlayForm.controls['qtr'].errors?.['required']) {
            <div class="error">
              {{ 'components.gamePlayEdit.qtrEstObligatoire' | transloco }}
            </div>
          }
        </div>
        <div class="col">
          <label>
            <span>{{ 'components.gamePlayEdit.playType' | transloco }}</span>
            <select formControlName="playType">
              <option value="" selected></option>
              @for (key of playTypeKeys; track key) {
                <option [value]="playTypeEnum[key]">{{playTypeEnum[key]}}</option>
              }
            </select>
          </label>
          @if (gamePlayForm.controls['playType'].errors?.['required']) {
            <div class="error">
              {{ 'components.gamePlayEdit.playTypeEstObligatoire' | transloco }}
            </div>
          }
          <label>
            <span>{{ 'components.gamePlayEdit.result' | transloco }}</span>
            <select formControlName="result">
              <option value="" selected></option>
              @for (key of playResultKeys; track key) {
                <option [value]="playResultEnum[key]">{{playResultEnum[key]}}</option>
              }
            </select>
          </label>
          @if (gamePlayForm.controls['result'].errors?.['required']) {
            <div class="error">
              {{ 'components.gamePlayEdit.resultEstObligatoire' | transloco }}
            </div>
          }
          <label>
            <span>{{ 'components.gamePlayEdit.gainLoss' | transloco }}</span>
            <input type="number" formControlName="gnLs">
          </label>
          <label>
            <span>{{ 'components.gamePlayEdit.kickYards' | transloco }}</span>
            <input type="number" formControlName="kickYards">
          </label>
          <label>
            <span>{{ 'components.gamePlayEdit.returnYards' | transloco }}</span>
            <input type="number" formControlName="returnYards">
          </label>
          <div class="penalty-item">
            <label>
              <span>{{ 'components.gamePlayEdit.penalty' | transloco }}</span>
              <select formControlName="penTeam">
                <option value="" selected></option>
                @for (key of penTeamKeys; track key) {
                  <option [value]="penTeamEnum[key]">{{key}}</option>
                }
              </select>
            </label>
            <label>
              <span>{{ 'components.gamePlayEdit.penYards' | transloco }}</span>
              <input type="number" formControlName="penYards">
            </label>
          </div>
        </div>
      </div>
      <br>
        <div class="row">
          <div class="col">
            <span class="homeAway">
              <span></span>
              <span class="home">{{ 'components.gamePlayEdit.home' | transloco }}</span>
              <span class="away">{{ 'components.gamePlayEdit.away' | transloco }}</span>
            </span>
            <label class="player">
              <span>{{ 'components.gamePlayEdit.rusher' | transloco }}</span>
              <input type="number" min="0" max="99" formControlName="rusher" (input)="checkValue($event)">
              <input type="number" formControlName="oppRusher">
            </label>
            <label class="player">
              <span>{{ 'components.gamePlayEdit.passer' | transloco }}</span>
              <input type="number" formControlName="passer">
              <input type="number" formControlName="oppPasser">
            </label>
            <label class="player">
              <span>{{ 'components.gamePlayEdit.receiver' | transloco }}</span>
              <input type="number" formControlName="receiver">
              <input type="number" formControlName="oppReceiver">
            </label>
            <label class="player">
              <span>{{ 'components.gamePlayEdit.kicker' | transloco }}</span>
              <input type="number" formControlName="kicker">
              <input type="number" formControlName="oppKicker">
            </label>
            <label class="player">
              <span>{{ 'components.gamePlayEdit.returner' | transloco }}</span>
              <input type="number" formControlName="returner">
              <input type="number" formControlName="oppReturner">
            </label>
          </div>
          <div class="col">
            <span class="homeAway">
              <span></span>
              <span class="home">{{ 'components.gamePlayEdit.home' | transloco }}</span>
              <span class="away">{{ 'components.gamePlayEdit.away' | transloco }}</span>
            </span>
            <label class="player">
              <span>{{ 'components.gamePlayEdit.tackler1' | transloco }}</span>
              <input type="number" formControlName="tackler1">
              <input type="number" formControlName="oppTackler1">
            </label>
            <label class="player">
              <span>{{ 'components.gamePlayEdit.tackler2' | transloco }}</span>
              <input type="number" formControlName="tackler2">
              <input type="number" formControlName="oppTackler2">
            </label>
            <label class="player">
              <span>{{ 'components.gamePlayEdit.battedDown' | transloco }}</span>
              <input type="number" formControlName="battedDown">
              <input type="number" formControlName="oppBattedDown">
            </label>
            <label class="player">
              <span>{{ 'components.gamePlayEdit.recoveredBy' | transloco }}</span>
              <input type="number" formControlName="recoveredBy">
              <input type="number" formControlName="oppRecoveredBy">
            </label>
            <label class="player">
              <span>{{ 'components.gamePlayEdit.forceFumbleBy' | transloco }}</span>
              <input type="number" formControlName="forcedFumbleBy">
              <input type="number" formControlName="oppForcedFumbleBy">
            </label>
            <label class="player">
              <span>{{ 'components.gamePlayEdit.interceptedBy' | transloco }}</span>
              <input type="number" formControlName="interceptedBy">
              <input type="number" formControlName="oppInterceptedBy">
            </label>
          </div>
        </div>
      </form>
    </section>
  }

  <footer>
    <button mat-flat-button data-testid="backGamePlayEdit" (click)="back()">{{ 'components.gamePlayEdit.back' | transloco }}</button>
    <button class="btn-save" mat-flat-button data-testid="saveGamePlayEdit" (click)="save()">{{ 'components.gamePlayEdit.save' | transloco }}</button>
  </footer>
